<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <div class="flex flex-row mb-3" style="align-items: center">
        <div class="head-title">
            Daily Reports <span *ngIf="blockedPanel"><p-progressSpinner [style]="{width: '20px', height: '25px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner></span>
        </div>

        <div class="mr-2 ml-auto">
            <p-multiSelect [options]="cities" placeholder="Select city"
                           optionLabel="Name" optionValue="Id" [(ngModel)]="filterStatistics.citiesId"
                           (ngModelChange)="handleFilterChange($event)" />
        </div>

        <div class="mr-2">
            <p-multiSelect [options]="vehicleTypes" placeholder="Select city"
                           optionLabel="name" optionValue="value" [(ngModel)]="filterStatistics.vehicleTypes"
                           (ngModelChange)="handleVehicleTypeFilterChange($event)" />
        </div>

        <div class="mr-2">
            <p-calendar [appendTo]="'body'"
                        [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                        selectionMode="range" [readonlyInput]="true" [showIcon]="true" [(ngModel)]="selectedDateRange"
                        (ngModelChange)="handleFilterChange($event)" />
        </div>
        <div class="report-customer-header__separator"></div>
        <div class="mr-2">
            <button style="height: 35px;" class="bluedark-btn" pButton label="Export Data" [loading]="loadingExportData" (click)="exportOrdersCompletedAndUnallocated(exportFileTypeEnum.CSV)"></button>
        </div>
    </div>

    <ng-container>
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[menuDailyReportActive]"></p-tabMenu>

        <div *ngIf="menuDailyReportActive === menuDailyReport.Report">
            <div class="card">
                <p-scrollPanel [style]="{width:'100%', height: 'calc(72vh)'}"
                               [styleClass]="'app-scrollpanel'">
                    <p-table [value]="orderStatistics" [tableStyle]="{'min-width': '50rem'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th rowspan="3">City</th>
                            </tr>
                            <tr>
                                <th colspan="4">Moto</th>
                                <th colspan="4">Sedan</th>
                                <th colspan="4">SUV</th>
                            </tr>
                            <tr>
                                <th>Completed</th>
                                <th>Unallocated</th>
                                <th>Unallocated %</th>
                                <th>Total</th>

                                <th>Completed</th>
                                <th>Unallocated</th>
                                <th>Unallocated %</th>
                                <th>Total</th>

                                <th>Completed</th>
                                <th>Unallocated</th>
                                <th>Unallocated %</th>
                                <th>Total</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-stat>
                            <tr>
                                <td>{{stat.City}}</td>
                                <!-- Moto -->
                                <ng-container>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Moto).CompletedCount }}</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Moto).UnallocatedCount }}</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Moto).UnallocatedPercent }} %</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Moto).Total }}</td>
                                </ng-container>

                                <!-- Sedan -->
                                <ng-container>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Sedan).CompletedCount }}</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Sedan).UnallocatedCount }}</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Sedan).UnallocatedPercent }} %</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.Sedan).Total }}</td>
                                </ng-container>

                                <!-- SUV -->
                                <ng-container>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.SUV).CompletedCount }}</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.SUV).UnallocatedCount }}</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.SUV).UnallocatedPercent }} %</td>
                                    <td>{{ getOrderStat(stat.OrderStatistics, vehicleTypeEnum.SUV).Total }}</td>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr>
                                <td class="text-right">Totals</td>
                                <td>{{totalCompletedMoto}}</td>
                                <td>{{totalUnallocatedMoto}}</td>
                                <td></td>
                                <td>{{totalCompletedMoto + totalUnallocatedMoto}}</td>

                                <td>{{totalCompletedSedan}}</td>
                                <td>{{totalUnallocatedSedan}}</td>
                                <td></td>
                                <td>{{totalCompletedSedan + totalUnallocatedSedan}}</td>

                                <td>{{totalCompletedSUV}}</td>
                                <td>{{totalUnallocatedSUV}}</td>
                                <td></td>
                                <td>{{totalCompletedSUV + totalUnallocatedSUV}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-scrollPanel>
            </div>
        </div>

        <div *ngIf="menuDailyReportActive === menuDailyReport.Map">
            <div id="map"
                 class="live-map-map"
                 [ngClass]="{
         'live-map-map-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
         'live-map-map-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic}"></div>
        </div>
    </ng-container>

</div>